import { Button, Input, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from '@nextui-org/react'
import { FC, useEffect, useState } from 'react'
import { MdUploadFile } from 'react-icons/md'
import { COURIER, TERMINO_ETIQUETA_LOWER } from '../constants'

/**
 * Modal reutilizable para cargar manualmente la etiqueta de DHL (PDF) cuando el
 * API falla. Pide el número de tracking de DHL (obligatorio) y el PDF.
 */
const UploadLabelModal: FC<{
  open: boolean
  store?: string
  busy?: boolean
  onClose: () => void
  onSubmit: (tracking: string, file: File) => void
}> = ({ open, store, busy = false, onClose, onSubmit }) => {
  const [tracking, setTracking] = useState('')
  const [file, setFile] = useState<File | null>(null)

  useEffect(() => { setTracking(''); setFile(null) }, [open])

  if (!open) return null
  const fileOk = file !== null && file.type === 'application/pdf'
  const ok = tracking.trim() !== '' && fileOk

  return (
    <Modal isOpen={open} onClose={onClose} size='lg' scrollBehavior='inside'>
      <ModalContent>
        <ModalHeader className='flex flex-col gap-0'>
          <span className='text-[10px] uppercase tracking-widest text-[#37417f]/60 font-bold'>Cargar {TERMINO_ETIQUETA_LOWER} {COURIER}</span>
          {store !== undefined && <span className='text-base font-bold text-[#151930]'>{store}</span>}
        </ModalHeader>
        <ModalBody className='gap-3'>
          <Input
            size='sm' label={`Número de tracking ${COURIER}`} isRequired
            value={tracking} onValueChange={setTracking}
            placeholder='Ej. 1234567890'
          />
          <div>
            <label className='inline-flex items-center gap-2 text-sm h-9 px-3 rounded-lg border border-[#e2e5f0] cursor-pointer hover:bg-[#f1f2f8]'>
              <MdUploadFile className='text-base' /> {file !== null ? 'Cambiar PDF' : 'Seleccionar PDF'}
              <input
                type='file' accept='application/pdf' hidden
                onChange={(e) => { setFile(e.target.files?.[0] ?? null) }}
              />
            </label>
            {file !== null && (
              <span className={`ml-2 text-xs ${fileOk ? 'text-[#151930]/60' : 'text-[#A32D2D]'}`}>
                {fileOk ? file.name : 'El archivo debe ser un PDF'}
              </span>
            )}
          </div>
          <p className='text-[11px] text-[#151930]/50'>El tracking es obligatorio: con él se sigue el envío en {COURIER}.</p>
        </ModalBody>
        <ModalFooter className='flex justify-end gap-2'>
          <Button variant='bordered' className='border-gray-200 text-[#151930]' onPress={onClose}>Cancelar</Button>
          <Button
            className='bg-[#151930] text-white font-semibold'
            isLoading={busy} isDisabled={!ok}
            startContent={busy ? undefined : <MdUploadFile className='text-sm' />}
            onPress={() => { if (file !== null) onSubmit(tracking.trim(), file) }}
          >
            Cargar etiqueta
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default UploadLabelModal
